import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import { FormBuilder, Form } from "react-formio";
import {
  fetchRuntimeFormData,
  fetchRuntimeFormDetails,
  filterRuntimeFormData,
  patchFormData,
} from "../services/FormService";
import CONSTANTS, {
  PRODUCT_CATEGORY_FORM_ID,
  PRODUCT_CODES_FORM_ID,
} from "../constants/constants";
import { Autocomplete, Button, TextField } from "@mui/material";
import RegisterProductCode from "./RegisterProductCode/RegisterProductCode";
import RegisterProductCategory from "./RegisterProductCategory/RegisterProductCategory";
import { pushNotification } from "../redux/actions";
import { useDispatch } from "react-redux";
import {
  fetchModelerForm,
  postModelerForm,
  postRuntimeModelerForm,
} from "../services/FormModelerService";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Colors from "../theme/colors.json";
import DataUpload from "./HistoricalDataUpload/DataUpload";

const builderOptions = {
  builder: {
    // data: false,
    // advanced: false,
    // layout: true,
    premium: false,
  },
  noDefaultSubmitButton: false,
};

const useStyles = makeStyles((theme) => ({
  registerProductContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",

    "@media (min-width: 1000px) and (max-width: 1500px)": {
      padding: "1%  0 2% 0",
    },
    "@media (min-width: 600px) and (max-width: 1000px)": {
      padding: "3.6%  0 2% 0",
    },
    "@media (max-width: 600px)": {
      padding: "10%  0 2% 0",
    },
  },
  pageHeading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "1.2rem",
    fontWeight: 600,
    color: theme.palette.primary.main,
    // paddingTop: 20,
    // paddingBottom: 30,
  },
  ProposalFormContainer: {
    display: "flex",
    flexDirection: "column",
    padding: 30,
    width: "100%",
    gap: 30,
  },
  formBuilderContainer: {
    width: "100%",
    height: "auto",
    padding: 30,
    "& .formio-component-label-hidden": {
      marginTop: 48,
    },
  },
  productSection: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: 18,
  },
  productSectionHeading: {
    fontSize: theme.fontSizes.LARGE,
    fontWeight: 800,
    lineHeight: "16px",
    color: theme.palette.secondary.main,
  },
  productSectionForm: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    width: "100%",
    gap: "2%",
  },
  productFormFieldContainer: {
    display: "flex",
    flexDirection: "column",
    width: "49%",
    gap: 5,
  },
  inputLabel: {
    fontSize: 16,
    fontWeight: 800,
  },
  input: {},
  proposalSaveBtn: {
    height: 40,
  },
  proposalBtnContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingTop: "2.7%",
    paddingLeft: "3%",
    gap: 15,
  },
  tabsContainer: {
    width: "100%",
    paddingTop: "3%",
    paddingBottom: "1%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  productRegisterTabs: {
    borderRadius: "0.5rem 0.5rem 0.5rem 0.5rem",
    background: Colors.WHITE_BACKGROUND,
    "&.MuiTabs-root .MuiTabScrollButton-root svg": {
      color: theme.palette.secondary.main,
    },
    "&.MuiTabs-root .MuiTabs-indicator": {
      backgroundColor: theme.palette.primary.main,
      height: "8%",
      borderRadius: "0.5vw 0.5vw 0 0",
    },
  },
  productRegisterTab: {
    textTransform: "capitalize",
    "&.Mui-selected": {
      // backgroundColor: theme.palette.secondary.main,
      color: `${theme.palette.primary.main} !important`,
      fontSize: theme.fontSizes.SMALL,
      fontWeight: 600,
    },
  },
  previewFormDialogContent: {
    width: "90vw",
  },
  customDialog: {
    "& .MuiDialog-paper": {
      maxWidth: "unset",
    },
  },
  tabsTableContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  tabsTableSection: {
    width: "70%",
  },
  tabsSection: {
    width: "70%",
  },
  createEditProposalContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "80%",
  },
}));

const RegisterProduct = () => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const [productCategories, setProductCategories] = useState<any>([]);
  const [productCodes, setProductCodes] = useState<any>([]);
  const [productTitle, setProductTitle] = useState("");
  const [productCategory, setProductCategory] = useState("");
  const [productCode, setProductCode] = useState({
    productCode: null,
    productTitle: "",
    proposalFormId: "",
    id: "",
    productStatus: "",
  });
  const [proposalForm, setProposalForm] = useState<any>({});

  const [proposalFormVersion, setProposalFormVersion] = useState("");

  const [tabvalue, setTabValue] = React.useState(0);

  const [formId, setFormId] = useState("");

  const [openPreview, setOpenPreview] = React.useState(false);

  const handleClickOpenPreview = () => {
    setOpenPreview(true);
  };
  const handleClosePreview = () => {
    setOpenPreview(false);
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const onFormSchemaChange = (schema) => {
    let form = {
      display: "form",
      ...schema,
    };

    if (form.display === "form") {
      setProposalForm(form);
    }
  };

  const getProductCategories = async () => {
    const response = await fetchRuntimeFormData(
      PRODUCT_CATEGORY_FORM_ID,
      0,
      10000
    );

    const filteredProductCategories = response?.data?.content?.map((item) => {
      return item?.formData?.productCategory;
    });

    setProductCategories(filteredProductCategories || []);
  };

  const handleGetProductCodes = async (key, value, id) => {
    const response = await filterRuntimeFormData(id, key, value);
    if (response?.success) {
      const filteredProductCodes = response?.data?.map((item) => {
        return {
          productCode: item?.formData?.productCode,
          productTitle: item?.formData?.productTitle,
          proposalFormId: item?.formData?.proposalFormId,
          id: item?.id,
          productStatus: item?.formData?.productStatus,
        };
      });

      setProductCodes(filteredProductCodes);
    } else {
      setProductCodes([]);
    }
  };

  const handleProductCategoryChange = (data) => {
    const { name, value } = data;
    setProductCategory(value);
    setProductCode({
      productCode: null,
      productTitle: "",
      proposalFormId: "",
      id: "",
      productStatus: "",
    });
    setProductTitle("");
    handleGetProductCodes(name, value, PRODUCT_CODES_FORM_ID);
  };

  const handleProductCodeChange = (data) => {
    const { name, value } = data;
    setProductCode(value);
    setProductTitle(value.productTitle);
    handleGetProposalForm(value.proposalFormId);
  };

  const handleGetProposalForm = async (formId) => {
    const response: any = await fetchModelerForm(formId);
    if (response.success) {
      setProposalForm(response?.data?.components);
      setProposalFormVersion(response?.data?.version);
      dispatch(
        pushNotification({
          isOpen: true,
          type: CONSTANTS.SUCCESS,
          message: response?.message,
        })
      );
    } else {
      setProposalForm({ display: "form", components: [] });
      dispatch(
        pushNotification({
          isOpen: true,
          type: CONSTANTS.SUCCESS,
          message: response?.message,
        })
      );
    }
  };

  const saveProposalForm = async (productCode) => {
    if (productCode.proposalFormId || formId) {
      const payload = {
        name: `${productCode.productTitle}${productCode.productCode}`,
        elasticPush: "disabled",
        components: proposalForm,
        id: productCode.proposalFormId || formId,
        type: "form",
      };

      const response = await postModelerForm(payload);
      if (response?.success) {
        dispatch(
          pushNotification({
            isOpen: true,
            type: CONSTANTS.SUCCESS,
            message: response?.message,
          })
        );
        setFormId(response?.data?.id);
        return response?.data?.id;
      } else {
        dispatch(
          pushNotification({
            isOpen: true,
            type: CONSTANTS.ERROR,
            message: response?.message,
          })
        );
        setFormId("");
        return "";
      }
    } else {
      const payload = {
        name: `${productCode.productTitle}${productCode.productCode}`,
        elasticPush: "disabled",
        components: proposalForm,
        type: "form",
      };
      const response = await postModelerForm(payload);
      if (response?.success) {
        dispatch(
          pushNotification({
            isOpen: true,
            type: CONSTANTS.SUCCESS,
            message: response?.message,
          })
        );
        setFormId(response?.data?.id);
        handleGetProposalForm(response?.data?.id);
        return response?.data?.id;
      } else {
        dispatch(
          pushNotification({
            isOpen: true,
            type: CONSTANTS.ERROR,
            message: response?.message,
          })
        );
        setFormId("");
        return "";
      }
    }
  };
  const deployProposalForm = async (productCode) => {
    const payload = {
      name: `${productCode.productTitle}${productCode.productCode}`,
      components: proposalForm,
      id: productCode.proposalFormId || formId,
      type: "form",
      version: proposalFormVersion,
    };

    const response = await postRuntimeModelerForm(payload);
    if (response?.success) {
      dispatch(
        pushNotification({
          isOpen: true,
          type: CONSTANTS.SUCCESS,
          message: response?.message,
        })
      );
    } else {
      dispatch(
        pushNotification({
          isOpen: true,
          type: CONSTANTS.ERROR,
          message: response?.message,
        })
      );
    }
  };

  const deleteProposalForm = () => {};

  const updateProductCodeForm = async (id) => {
    const payload = {};
  };

  const handleProductProposalLinking = async (productCode) => {
    try {
      const proposalId = await saveProposalForm(productCode); // Assuming saveProposalForm is an asynchronous API call
      if (proposalId && !productCode.proposalFormId) {
        const payload = {
          formId: PRODUCT_CODES_FORM_ID,
          id: productCode.id,
          formData: {
            proposalFormId: proposalId,
          },
        };
        const response = await patchFormData(payload);
        if (response?.success) {
          dispatch(
            pushNotification({
              isOpen: true,
              type: CONSTANTS.SUCCESS,
              message: response?.message,
            })
          );
        } else {
          dispatch(
            pushNotification({
              isOpen: true,
              type: CONSTANTS.ERROR,
              message: response?.message,
            })
          );
        }
      } else if (proposalId && productCode.proposalFormId) {
        dispatch(
          pushNotification({
            isOpen: true,
            type: CONSTANTS.SUCCESS,
            message: `Proposal form is successfully linked with the ${productCode.productTitle}`,
          })
        );
      }
    } catch (error) {
      // Handle any errors that may occur during the API call
      dispatch(
        pushNotification({
          isOpen: true,
          type: CONSTANTS.ERROR,
          message: error,
        })
      );
    }
  };

  const handleTabSwitching = (tab) => {
    switch (tab) {
      case 0:
        return (
          <div className={classes.tabsTableSection}>
            <DataUpload />
          </div>
        );
      case 1:
        return (
          <div className={classes.tabsTableSection}>
            <RegisterProductCategory />
          </div>
        );
      case 2:
        return (
          <div className={classes.tabsTableSection}>
            <RegisterProductCode />
          </div>
        );
      case 3:
        return (
          <div className={classes.createEditProposalContainer}>
            <div className={classes.pageHeading}>
              Create/Edit Proposal Form For The Product
            </div>
            <div className={classes.ProposalFormContainer}>
              <div className={classes.productSection}>
                {/* <div className={classes.productSectionHeading}>
                  Product Selection
                </div> */}
                <div className={classes.productSectionForm}>
                  <div className={classes.productFormFieldContainer}>
                    <label className={classes.inputLabel}>
                      Product Category
                    </label>
                    <Autocomplete
                      id="product-category"
                      className={classes.input}
                      options={productCategories}
                      getOptionLabel={(option) => option}
                      value={productCategory}
                      onChange={(_, newValue: any) =>
                        handleProductCategoryChange({
                          name: "productCategory",
                          value: newValue,
                        })
                      }
                      disableClearable={true}
                      renderInput={(params) => (
                        <TextField {...params} size="small" />
                      )}
                    />
                  </div>
                  <div className={classes.productFormFieldContainer}>
                    <label className={classes.inputLabel}>Product Title</label>
                    <Autocomplete
                      id="product-code"
                      className={classes.input}
                      options={productCodes}
                      getOptionLabel={(option: any) =>
                        option?.productTitle?.toString() || ""
                      }
                      getOptionDisabled={(option) =>
                        option.productStatus === "InActive"
                      }
                      value={productCode}
                      onChange={(_, newValue: any) =>
                        handleProductCodeChange({
                          name: "productCode",
                          value: newValue,
                        })
                      }
                      disableClearable={true}
                      renderInput={(params) => (
                        <TextField {...params} size="small" />
                      )}
                    />
                  </div>
                  {/* <div className={classes.productFormFieldContainer}>
                    <label className={classes.inputLabel}>Product Type</label>
                    <TextField
                      id="product-title"
                      className={classes.input}
                      value={productTitle}
                      size="small"
                    />
                  </div> */}
                  {productCategory &&
                  productCode.productCode &&
                  productCode.productTitle ? (
                    <div className={classes.proposalBtnContainer}>
                      <Button
                        size="small"
                        className={classes.proposalSaveBtn}
                        variant="contained"
                        onClick={() =>
                          handleProductProposalLinking(productCode)
                        }
                      >
                        Save Form
                      </Button>
                      <Button
                        size="small"
                        className={classes.proposalSaveBtn}
                        variant="contained"
                        color="secondary"
                        onClick={() => deployProposalForm(productCode)}
                      >
                        Publish Form
                      </Button>
                      <Button
                        size="small"
                        className={classes.proposalSaveBtn}
                        variant="contained"
                        onClick={handleClickOpenPreview}
                      >
                        Preview Form
                      </Button>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
            {productCode.productCode ? (
              <div className={classes.formBuilderContainer}>
                <FormBuilder
                  options={builderOptions}
                  form={proposalForm}
                  onChange={(schema) => {
                    onFormSchemaChange(schema);
                  }}
                />
              </div>
            ) : null}
          </div>
        );

      default:
        return null;
    }
  };

  useEffect(() => {
    if (tabvalue === 2) getProductCategories();

    return () => {
      setProductCategory("");
      setProductCode({
        productCode: null,
        productTitle: "",
        proposalFormId: "",
        id: "",
        productStatus: "",
      });
      setProductTitle("");
    };
  }, [tabvalue]);

  return (
    <div className={classes.registerProductContainer}>
      <Dialog
        onClose={handleClosePreview}
        aria-labelledby="customized-dialog-preview"
        open={openPreview}
        className={classes.customDialog}
        fullWidth
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-preview">
          Form Preview
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClosePreview}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Form
            form={proposalForm}
            onSubmit={(submission) => console.log(submission?.data)}
          />
        </DialogContent>
        <DialogActions>
          {/* <Button
            autoFocus
            color="secondary"
            variant="contained"
            onClick={handleClosePreview}
          >
            Close
          </Button> */}
        </DialogActions>
      </Dialog>
      {/* <div className={classes.pageHeading}>Register Product</div> */}
      <div className={classes.tabsContainer}>
        <div className={classes.tabsSection}>
          <Tabs
            id="Product-Register-Tabs"
            value={tabvalue}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
            className={classes.productRegisterTabs}
          >
            <Tab
              className={classes.productRegisterTab}
              label="Historical Data Upload"
            />
            <Tab
              className={classes.productRegisterTab}
              label="Product Category"
            />
            <Tab
              className={classes.productRegisterTab}
              label="Product Code/Title"
            />
            <Tab
              className={classes.productRegisterTab}
              label="Proposal Details"
            />
          </Tabs>
        </div>
      </div>
      <div className={classes.tabsTableContainer}>
        {handleTabSwitching(tabvalue)}
      </div>
    </div>
  );
};

export default RegisterProduct;
